<template>
  <home-floating-window
    :title="$t('ExternalImport')"
    @close="closeExternalImportWindow"
    @changePosition="$emit('changeExternalImportWindowPosition', $event)"
    :draggable="!loading && !dragIsDisabled"
    :height="300"
  >
    <template v-slot:iconWindows>
      <ExternalImport class="floating-container-svg" />
    </template>

    <template v-slot:objectDivWindows>
      <div class="floating-tool-content">
        <div class="external-import-objects-div">
          <HighlightedBox
            :bad-object="badObject"
            :is-visible="showInstruction"
            :message="currentInstruction"
          />

          <label>{{ $tc("Service", 1) }}</label>
          <treeselect
            v-model="service"
            :options="serviceOptions"
            :placeholder="null"
            :searchable="false"
          />

          <label>{{ $tc("Layer", 1) }}</label>
          <treeselect
            v-model="layers"
            :options="layerOptions"
            :placeholder="null"
            :searchable="false"
            :default-expand-level="1"
            multiple
          />
        </div>
      </div>

      <home-window-button
        :label="externalImportSubmitButtonLabel"
        :disabled="externalImportSubmitButtonDisabled"
        @buttonClick="importExternalData"
      />

      <loading-spinner
        :active.sync="loading"
        :is-full-page="true"
        color="accent"
      />
    </template>
  </home-floating-window>
</template>

<script>
import { bus } from "@/main";
import { mixin as clickaway } from "vue-clickaway";
import HomeFloatingWindow from "../HomeFloatingWindow";
import ExternalImport from "@/assets/external_import_svgs/external_import.svg";
import HighlightedBox from "@/components/_Molecules/HighlightedBox";
import LoadingSpinner from "vue-loading-overlay";
import HomeWindowButton from "../../HomeWindowButton";
import { mapActions } from 'vuex';
import { importMixin } from "@/mixins/management/importMixin";

export default {
  name: "ExternalImportWindow",

  components: {
    HomeFloatingWindow,
    ExternalImport,
    HighlightedBox,
    LoadingSpinner,
    HomeWindowButton,
  },

  mixins: [clickaway, importMixin],

  data() {
    return {
      badObject: false,
      service: null,
      layers: null,
      serviceOptions: [],
      loading: false,
      dragIsDisabled: false,
      allLayers: ["fc_manhole", "fc_pathway", "fc_pole"]
    }
  },

  mounted() {
    bus.$on("escape-external_import", () => this.closeExternalImportWindow());
    bus.$on("deactivate-external_import", () => this.closeExternalImportWindow());
    this.loadServiceOptions();
  },

  destroyed() {
    bus.$off("deactivate-external_import");
    bus.$off("escape-external_import");
  },

  computed: {
    /**
     * Indicates if the instruction is shown or not
     */
     showInstruction() {
      return this.currentInstruction !== "";
    },

    /**
     * Returns the instruction for the creation
     */
    currentInstruction() {
      return this.$t("StartDrawingPolygonInstruction");
    },

    /**
     * Returns the label of the form button
     */
    externalImportSubmitButtonLabel() {
      return this.$tc("ImportNoun", 1);
    },

    /**
     * Indicates if the button is disabled or not
     */
    externalImportSubmitButtonDisabled() {
      return !(this.service && this.layers && this.layers.length > 0);
    },

    layerOptions() {
      let options = [
        {
          id: 'all',
          label: this.$i18n.t("All"),
          children: []
        }
      ]
      this.allLayers.forEach(layer => {
        options[0].children.push({
          id: layer,
          label: this.getLayerName(layer)
        })
      });
      return options;
    }
  },

  methods: {
    ...mapActions(["fetchIntegrations"]),

    /**
     * Closes the window
     */
    closeExternalImportWindow() {
      this.$emit("close");
    },

    /**
     * Loads list of service options.
     */
    async loadServiceOptions() {
      this.loading = true;
      try {
        let includes = null;
        let allServiceOptions = await this.fetchIntegrations(includes);
        for (let i = 0; i < allServiceOptions.length; i++) {
          if (allServiceOptions[i].integration_type === "OpenReach") {
            this.serviceOptions.push({
              id: allServiceOptions[i].uuid,
              label: allServiceOptions[i].name,
            })
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    importExternalData() {
      let layers = [];
      if (this.layers[0] === "all") {
        layers = this.allLayers
      } else {
        layers = this.layers
      }
      this.$emit("importExternalData", {
        layers: layers,
        service: this.service
      });
    }
  }
}

</script>

<style scoped>
.external-import-objects-div {
  padding: 5px 10px;
  min-height: 130px;
  text-align: left;
}

.external-import-objects-div > .select-object {
  margin-top: 0;
  margin-bottom: 10px;
  text-align: center;
}

.vue-treeselect {
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/ExternalImport/ExternalImportWindow.vue